enum SandboxStatus {
  ACTIVE = "active",
  COMPLETED = "completed",
  ERRORED = "errored",
  CLONING = "cloning",
  DELETING = "deleting",
}

export default SandboxStatus;
